import {Component, Input, OnInit} from '@angular/core';
import {ProdutoService} from "../../../services/produto.service";
import {ConstantsService} from "../../../fidelidade/ConstantsService";
import {OpcaoDeAdicionalDeProduto} from "../../../../../server/domain/delivery/OpcaoDeAdicionalDeProduto";

@Component({
  selector: 'app-adicionais-produto',
  templateUrl: './adicionais-produto.component.html',
  styleUrls: ['./adicionais-produto.component.scss']
})
export class AdicionaisProdutoComponent {
  carregando: any;

  private _produto: any;

  grupos = [];
  @Input()
  empresa: any;
  processando = false;

  @Input()
  catalogo: any;

  constructor(private produtoService: ProdutoService) {
  }

  @Input() set produto(value: any) {
    this._produto = value;

    this.grupos = [];

    const camposAdicionais = this._produto && this._produto.camposAdicionais ? this._produto.camposAdicionais : [];

    for( let campo of camposAdicionais ) {
      if( campo.opcoesDisponiveis ) {
        const grupo: any = {
          nome: campo.nome,
          obrigatorio: campo.obrigatorio,
          opcoes: []
        };

        for (let opcao of campo.opcoesDisponiveis) {
          grupo.opcoes.push(opcao);
        }

        if(grupo.opcoes.length)
          this.grupos.push(grupo);
      }
    }
  }

  get produto(): any {
    return this._produto;
  }

  labelQuantidadeOpcoes(grupo: any): string {
    const total = grupo && grupo.opcoes ? grupo.opcoes.length : 0;

    return total + (total === 1 ? ' opção' : ' opções');
  }

  opcaoDisponivel(opcao: any) {
    const disponibilidadePorEmpresa = this.catalogo && this.catalogo.disponibilidadePorEmpresa;

    return disponibilidadePorEmpresa && opcao.opcaoNaEmpresa && opcao.opcaoNaEmpresa.id
      ? opcao.opcaoNaEmpresa.disponivel
      : opcao.disponivel;
  }

  pausarAdicional(opcao: OpcaoDeAdicionalDeProduto) {
    this.processando = true;

    this.produtoService.pausarAtivarOpcional(this.empresa, opcao, false, this.catalogo).then( (resposta: any) => {
      if(this.catalogo.disponibilidadePorEmpresa && opcao.opcaoNaEmpresa && opcao.opcaoNaEmpresa.id)
        opcao.opcaoNaEmpresa.disponivel = false
      else
        opcao.disponivel = false;

      this.processando = false;
    }).catch( (erro: any) => {
      this.processando = false;
    });
  }

  ativarAdicional(opcao: any) {
    this.processando = true;

    this.produtoService.pausarAtivarOpcional(this.empresa, opcao, true, this.catalogo).then( (resposta: any) => {
      if(this.catalogo.disponibilidadePorEmpresa && opcao.opcaoNaEmpresa && opcao.opcaoNaEmpresa.id)
        opcao.opcaoNaEmpresa.disponivel = true
      else
        opcao.disponivel = true;

      this.processando = false;
    }).catch( (erro: any) => {
      this.processando = false;
    });
  }
}
